module.exports = __webpack_public_path__ + "static/img/m3.f8d3181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m3.png
// module id = wbM3
// module chunks = 12